import styles from './CardInfo.module.css';
import iconAlert from '../../../assets/img/icons/alert-circle.png';

interface CardInfoProps {
    title: string,
    children: React.ReactNode,
    marginTop?: string,
}

export const CardInfo = ({ title, children, marginTop = '0px' }: CardInfoProps) => {
    return (
        <div className={styles.card} style={{ marginTop: marginTop }}>
            <div className={styles.card__icon__column}>
                <img src={iconAlert} alt="Alert" className={styles.card__icon} />
            </div>
            <div className={styles.card__info__column}>
                <div className={styles.card__title}>{title}</div>
                <div className={styles.card__info}>{children}</div>
            </div>
        </div>
    )
}
